import React, { FC, ReactElement } from 'react';
import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  FieldErrors,
  UseFormReturn,
  UseFormStateReturn,
} from 'react-hook-form';
import { ScheduledEventForm } from '../models/ScheduledEventDto';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { TasmotaPowerDeviceConfig } from '@thingslog/repositories';
import { useTranslation } from 'react-i18next';

export const TasmotaEvent: FC<TasmotaEventProps> = ({ form }: TasmotaEventProps) => {
  const {
    register,
    control,
    formState: { errors: formErrors },
  } = form;

  const { t } = useTranslation();

  const errors = formErrors.event as FieldErrors<TasmotaPowerDeviceConfig>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
      <div>
        <TextField
          label={t('sensor_index')}
          variant="outlined"
          type="number"
          {...register('event.sensorIndex', { valueAsNumber: true })}
          error={!!errors?.sensorIndex}
          helperText={errors?.sensorIndex?.message ?? ''}
          size="small"
          fullWidth
          inputProps={{ min: 0 }}
        />
      </div>
      <div>
        <FormControl fullWidth size="small" error={!!errors?.requiredState}>
          <InputLabel id="required-state-label">
            {t('scheduled_task_event_form_relay_state')}
          </InputLabel>
          <Controller
            name="event.requiredState"
            control={control}
            render={({
              field,
            }: {
              field: ControllerRenderProps<ScheduledEventForm, 'event.requiredState'>;
              fieldState: ControllerFieldState;
              formState: UseFormStateReturn<ScheduledEventForm>;
            }): ReactElement => (
              <Select
                {...field}
                labelId="required-state-label"
                label={t('scheduled_task_event_form_relay_state')}
              >
                <MenuItem value="ON">{t('on')}</MenuItem>
                <MenuItem value="OFF">{t('off')}</MenuItem>
              </Select>
            )}
          />
          {errors?.requiredState && <FormHelperText>{errors.requiredState.message}</FormHelperText>}
        </FormControl>
      </div>
    </div>
  );
};

interface TasmotaEventProps {
  form: UseFormReturn<ScheduledEventForm, unknown, undefined>;
}
